export default __webpack_public_path__ + "static/media/feto.01b4b2c6.png";